import styles from './Button.module.css'

export default function Button(props){

  return (<a className={styles.btn} href={props.href} target="_blank" nofollow>
    <p className={styles.inner} dangerouslySetInnerHTML={{__html: props.text}}></p>
  </a>);
}
